  $(document).on('click', '.product_tab_addToCart', async function () {
    const button = $(this); // clicked button
    const variantId = button.data('variant-id'); // product variant id

    if (!variantId || button.hasClass('loading')) return;

    try {
      // -------------------------------
      // 1️⃣ Disable button + show loader
      // -------------------------------
      button.addClass('loading');
      button.find('.btn-text').text('Adding...');

      // -------------------------------
      // 2️⃣ Add product to cart
      // -------------------------------
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      });

      if (!addResponse.ok) throw new Error('Failed to add product');

      // -------------------------------
      // 3️⃣ Get updated cart
      // -------------------------------
      const cart = await fetch('/cart.js').then((res) => res.json());

      // Update cart count bubble
      $('.cart-count-bubble span[aria-hidden="true"]').text(cart.item_count);
      $('.cart-count-bubble .visually-hidden').text(cart.item_count + ' item');

      // -------------------------------
      // 4️⃣ Refresh Cart Drawer
      // -------------------------------
      const drawerData = await fetch('/?sections=cart-drawer').then((res) => res.json());

      const parser = new DOMParser();
      const html = parser.parseFromString(drawerData['cart-drawer'], 'text/html');

      const newDrawer = html.querySelector('#CartDrawer');
      const currentDrawer = document.querySelector('#CartDrawer');

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }

      // -------------------------------
      // 5️⃣ Open cart drawer
      // -------------------------------
      const drawer = document.querySelector('cart-drawer');

      if (drawer) {
        drawer.classList.remove('is-empty');
        drawer.open();
      }
    } catch (error) {
      console.error('Add to cart error:', error);
      alert('Unable to add product. Please try again.');
    } finally {
      // -------------------------------
      // 6️⃣ Restore button
      // -------------------------------
      button.removeClass('loading');
      button.find('.btn-text').text('Add to cart');
    }
  });